export default [
    {
        title: "mainmenu.insights",
        route: "insights",
        icon: "chart-simple",
        class: "d-none d-sm-block",
        resource: "insights",
        action: "read",
    },
];
